<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
    </section>
  
    <div class="seven3css">
      <SeventyThirtysection :LeftsideText="dividendpolicyinfo" :RightsideText="dividendshighlight" 
     leftsectheme="leftseccss" />

      <div class="col-xs-12 col-sm-12rounded datadiv1" data-aos="fade-up">
        <table class="tablewidth">
        <thead>
            <tr>
                <th scope="col" class="tdhead">{{ dividendl1 }}</th>
                <th scope="col" class="tdhead">{{ dividendl2 }}</th>
                <th scope="col" class="tdhead">{{ dividendl3 }}</th>
                <th scope="col" class="tdhead">{{ dividendl4 }}</th>
            </tr>
        </thead>
          <tr  v-for="(dtd, index) in dividendtabledata" :key="index" class="formatrow">
            <td v-html="`${dtd.netcash}`" class="formattd" :class="`td${index%2}`"></td>
            <td v-html="`${dtd.basedividend}`" class="formattd" :class="`td${index%2}`"></td>
            <td v-html="`${dtd.vardivided}`" class="formattd" :class="`td${index%2}`"></td>
            <td v-html="`${dtd.totaldividend}`" class="formattd" :class="`td${index%2}`"></td>
        
          </tr>
        </table>
      </div>
      <div class="dividendtxt">
        <hr />
        <span v-html="dividendpolicyinfobottomtext"></span>
        
       </div>
    </div>

    <section>
      <div class="col-xs-12 col-sm-12rounded datadiv2" data-aos="fade-up">
        <hr class="hrwidth" />
        <div v-html="dividendscheduletext" class="scheduletext"></div>
        <table class="tablewidth">
        <thead>
            <tr>
                <th scope="col" class="tdhead">{{ schedulel1 }}</th>
                <th scope="col" class="tdhead">{{ schedulel2 }}</th>
                <th scope="col" class="tdhead">{{ schedulel3 }}</th>
                <th scope="col" class="tdhead">{{ schedulel4 }}</th>
            </tr>
        </thead>
          <tr  v-for="(dtd, index1) in dividendscheduledata" :key="index1" class="formatrow"  align="center">
            <td class="formattd" :class="`td${index1%2}`">{{dateTime(dtd.schdivdate)}}</td>
            <td class="formattd"  :class="`td${index1%2}`">{{dateTime(dtd.schrecdate)}}</td>
            <td  class="formattd"  :class="`td${index1%2}`">{{dateTime(dtd.schpaydate)}}</td>
            <td v-html="`$${dtd.schamount}`" class="formattd"  :class="`td${index1%2}`"></td>        
          </tr>
        </table>
      </div>
    </section>

  <div style="padding: 100px;">
    <hr />
    <div v-html="bottomtext" style="text-align: center;">
    </div>
  </div>
    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';

require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import Chart from 'chart.js/auto';
import axios from 'axios';
import moment from 'moment';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, SeventyThirtysection
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  dividendshighlight: '',

  investallinfo: [],
  dividendpolicyinfo: '',

  dividendl1: '',
  dividendl2: '',
  dividendl3: '',
  dividendl4: '',
  schedulel1: '',
  schedulel2: '',
  schedulel3: '',
  schedulel4: '',
  dividendscheduledata: [],
  dividendtabledata: [],
  dividendpolicyinfobottomtext: '',
  dividendpolicytext: '',
  dividendscheduletext: '',

  breadcrumbsinfo: [],

  height: 0,
  width: 0,
  }
},

methods: {
  dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
},

async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/dividends').then(
    response => {
      this.videoimage = response.data

      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
        console.log(error)
      })

 //-----------All invest page report data--------------
 axios.get('getinvestinfo/').then(
    response => {
        this.investallinfo = response.data
        this.dividendpolicyinfo = response.data[0].dividendpolicyinfo
        this.dividendpolicyinfobottomtext = response.data[0].dividendpolicyinfobottomtext
        this.dividendpolicytext = response.data[0].dividendpolicytext
        this.dividendscheduletext = response.data[0].dividendscheduletext
    })
  .catch((error) => {
      console.log(error)
    })

//-----------Homepage News section-------------
await axios.get('homepagenewslisting/').then(
    response => {
        this.homepagenews = response.data.results
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  await axios.get('getallhiglights/dividends').then(
    response => {
        this.dividendshighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

 //------------all highlights---------------
 await axios.get('getdividendlabels/').then(
    response => {
    this.dividendl1 = response.data[0].dividendl1
    this.dividendl2 = response.data[0].dividendl2
    this.dividendl3 = response.data[0].dividendl3
    this.dividendl4 = response.data[0].dividendl4
    this.schedulel1 = response.data[0].schedulel1
    this.schedulel2 = response.data[0].schedulel2
    this.schedulel3 = response.data[0].schedulel3
    this.schedulel4 = response.data[0].schedulel4
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  await axios.get('getdividendtabledata/').then(
  response => {
      this.dividendtabledata = response.data
  })
  .catch((error) => {
      console.log(error)
    })
  //------------all highlights---------------
  await axios.get('getdividendscheduledata/').then(
  response => {
      this.dividendscheduledata = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/dividends').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })
    

}
}
</script>

<style scoped>

.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}
.seven3css {
  margin-top: 250px;
}
.td0 {
  background-color: rgb(221, 228, 235);
  border-top: thin orangered solid;
  border-bottom: thin orangered solid;
  padding: 10px;
}
.td1 {
  padding: 10px;
}
.tdhead {
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.datadiv2 {
  padding-top: 100px;
}
.dividendtext, .scheduletext {
  font-size: 26px;
  font-weight: bold;
  color: #003;
  padding-bottom: 30px
}
.datadiv1 {
  background-color: rgb(244, 247, 247);
  padding-top: 100px;
  padding-bottom: 100px;
}
.breadcrumbcss {
  padding-bottom: 40px;
}
.leftseccss {
  padding-top: -40px;
}

/* Move the background and make it larger. 
/* Media Query CSS*/
/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
  .datadiv1, .datadiv2 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .tdhead {
    font-size: 14px;
  }
  .dividendtxt {
    padding: 30px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .datadiv1, .datadiv2 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .tdhead {
    font-size: 14px;
  }
  .dividendtxt {
    padding: 30px;
  }
  .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .datadiv1, .datadiv2 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .tdhead {
    font-size: 14px;
  }
  .dividendtxt {
    padding: 30px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 700px;
    padding-right: 10px;
  }
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .datadiv1, .datadiv2  {
    padding-left: 100px;
  }
  .dividendtxt {
    padding-left: 100px;
    padding-right: 100px;
  }
  .hrwidth {
    width: 62%;
    color: #003;
    height:10px;

  }
  .tablewidth {
    width:80%;
    padding-left: 100px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {

}
</style>
